import {getAuthorRecord} from "./data/stories";
// Review preview: external writes and authentication are disconnected.
export const trackView = async () => null;
export const fetchTrending = async () => null;
export const searchStories = async () => null;
export const fetchApplause = async () => null;
export const sendApplause = async () => null;
export const fetchNewsletterPrefs = async () => null;
export const saveNewsletterPrefs = async () => null;
export const adminLogin = async () => null;
export const createStory = async () => null;
export const updateStory = async () => null;
export const deleteStory = async () => null;
export const fetchWeather = async () => null;
export const fetchAuthor = async (slug) => getAuthorRecord(slug);
export const fetchAuthors = async () => [];
export const saveAuthorBio = async () => null;
export const uploadAuthorAvatar = async () => null;
export const deleteAuthorAvatar = async () => null;
export const fetchFrontpage = async () => {} ;
export const saveFrontpage = async () => null;
export const renameAuthor = async () => null;
export const publishStoryNow = async () => null;
export const registerReader = async () => null;
export const loginReader = async () => null;
export const logoutReader = async () => null;
export const exchangeGoogleSession = async () => null;
export const forgotPassword = async () => null;
export const trackSponsored = async () => null;
